import { h, Fragment } from 'preact'
import { isMobile } from '../../js/modules/utilities.js'

export const Publicite = (props) => {
   return <Fragment>{isMobile() ? <PubliciteMobile {...props} /> : <PubliciteDesktop {...props} />}</Fragment>
}

const PubliciteMobile = ({ adsId, type }) => {
   if (type === 'masthead1') {
      return (
         // Par defaut le masthead est invisible, c'est adgateway qui modifie le style pour le rendre visible
         <div class="ad-with-border">
            <div id="ad1" style="height:0; overflow: hidden; width:320px; margin: 0 auto;">
               <div class="tag-masthead">
                  <div id={adsId} class="text-center"></div>
               </div>
            </div>
         </div>
      )
   } else if (type === 'masthead2') {
      return (
         // Par defaut le masthead est invisible, c'est adgateway qui modifie le style pour le rendre visible
         <div class="ad-with-border pt-2 mb-2">
            <div id="ad2" style="height:0; overflow: hidden; width:320px; margin: 0 auto;">
               <div class="tag-masthead">
                  <div id={adsId} class="text-center"></div>
               </div>
            </div>
         </div>
      )
   } else if (type === 'native') {
      return <div id={adsId} data-testid="bande-pub-native"></div>
   }
}

const PubliciteDesktop = ({ adsId, type }) => {
   if (type === 'masthead1') {
      return (
         // Par defaut le masthead est invisible, c'est adgateway qui modifie le style pour le rendre visible
         <div class="container-fluid">
            <div id="ad" style="height:0; overflow: hidden;" class="mx-auto mb-1" data-testid="bande-masthead">
               <div id={adsId} class="tag-masthead mt-2 text-center"></div>
            </div>
         </div>
      )
   } else if (type === 'lienscommerciaux') {
      return (
         <div class="container-fluid">
            <div id={adsId} class="mb-4" widget-id="SF_1" data-testid="bande-liens-commerciaux"></div>
         </div>
      )
   } else {
      let params = {}
      switch (type) {
         case 'rm':
            params = {
               class: 'tag-rm',
               'data-testid': 'bande-pub-rm',
            }
            break
         case 'native':
            params = {
               class: 'tag-native',
               'data-testid': 'bande-pub-native',
            }
            break
      }
      return <div id={adsId} {...params}></div>
   }
}
